export default class QtyButtons {
	constructor(input, allowZero) {

		this.input = input;
		this.allowZero = allowZero || false;
		this.add = jQuery('<div class="qty-button qty-add"><span class="screen-reader-text">Increase quantity</span><span>+</span></div>');
		this.minus = jQuery('<div class="qty-button qty-minus"><span class="screen-reader-text">Decrease quantity</span><span>-</span></div>');
		this.qty = jQuery(input);

		this.input.parent().append(this.add).append(this.minus);



		this.add.on('click', this.increment.bind(this));
		this.minus.on('click', this.decrement.bind(this));
	}

	increment() {
		let max = this.qty.attr('max');
		let qty = parseInt(this.qty.val());
		qty++;
		if (max && max < qty) {
			this.qty.val(max);
		} else {
			this.qty.val(qty);
		}

		this.input.trigger('change');
	}

	decrement() {
		let qty = parseInt(this.qty.val());
		qty--;

		if (!this.allowZero) {
			if (qty < 1) {
				qty = 1;
			}
		} else {
			if (qty < 0) {
				qty = 0;
			}
		}


		this.qty.val(qty);
		this.input.trigger('change');
	}
}